module.exports = __webpack_public_path__ + "static/img/Slice 19.8ea3a783.png";